import type { FC } from "react";
import type { Question, QuestionAnswerValue } from "../../../api/dto/Question";
import { localizeText } from "../../../util/localizeText";
import { Input } from "../../form/Input";
import { Select } from "../../form/Select";

export const QuestionAnswerCell: FC<{
  question: Question;
  value: QuestionAnswerValue;
  onChange: (value: QuestionAnswerValue) => void;
}> = ({ question, value, onChange }) => {
  switch (question.type) {
    case "boolean_question":
      return (
        <Select
          label={""}
          options={{ "": "-", true: "Ja", false: "Nee" }}
          value={value === true ? "true" : value === false ? "false" : ""}
          onChange={(v) => onChange(v === "" ? null : v === "true")}
        />
      );
    case "multi_question": {
      const selectedIndex = typeof value === "number" ? value : null;
      return (
        <div className={"grid grid-cols-2 gap-1.5"}>
          {(question.options ?? []).map((option, index) => {
            const selected = selectedIndex === index;
            const danger = option.abort || option.generatesFinding;
            const label = localizeText(option.label);
            return (
              <button
                key={label}
                type={"button"}
                onClick={() => onChange(selected ? null : index)}
                className={`text-left text-sm px-3 py-1.5 rounded-md border transition-colors ${
                  selected
                    ? danger
                      ? "bg-red-600 border-red-600 text-white font-medium"
                      : "bg-brand-800 border-brand-800 text-white font-medium"
                    : danger
                      ? "border-red-200 text-red-700 hover:bg-red-50"
                      : "border-slate-200 text-slate-700 hover:bg-slate-50"
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
      );
    }
    case "value_question":
      return (
        <Input
          type={"number"}
          label={""}
          value={typeof value === "number" ? value : 0}
          onChange={onChange}
        />
      );
    case "text_question":
      return (
        <Input
          type={"textarea"}
          label={""}
          value={typeof value === "string" ? value : ""}
          onChange={onChange}
          maxWidth={"full"}
        />
      );
    default:
      // gps_question and logic_* (computed) question types: read-only display for now.
      return (
        <div className={"text-sm text-slate-500"}>
          {value === null || value === undefined ? "-" : String(value)}
          <span className={"ml-2 text-xs uppercase text-slate-400"}>(automatisch)</span>
        </div>
      );
  }
};
